import { UserDto } from '../config/userConfig'
import { useContext, useMemo } from 'react'
import GlobalContext from '../context/GlobalContext'

type ReturnProps = {
    loaded: boolean
    users: UserDto[]
}

export default function useUsers(): ReturnProps {
    const { users } = useContext(GlobalContext)
    const loaded = useMemo<boolean>(() => users.length > 0, [users])

    return { loaded, users }
}
